import { login, logout, getInfo, wechatBind,qrcodeLogin } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

import {
	Message,
	MessageBox,
  Loading
} from 'element-ui'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    userInfo:{},
    code_key:'',        //获取二维码时候返回的codekey

  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERINFO: (state, info) => {
      state.userInfo = info
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_CODEKEY: (state, code_key) => {
      state.code_key = code_key
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      // console.log('userInfo',userInfo)
      return new Promise((resolve, reject) => {
        // login(username, userInfo.password,userInfo.captcha).then(response => {
        login(userInfo).then(response => {
          // console.log('response',response.data)
          if (response.data.status==200) {
            const data = response.data
            // const tokenStr = data.tokenHead+data.token
            const tokenStr = data.token
            // console.log('tokenStr',tokenStr)
            setToken(tokenStr)
            commit('SET_TOKEN', tokenStr)
            resolve()

          } else{
             Message.error(response.data.msg);
             let loadingInstance = Loading.service(options);
             loadingInstance.close();
             // window.location.reload();
          }
          // resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.pic)
          commit('SET_USERINFO', data)

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // // 微信二维码绑定接口
    // getWechatBind({ commit, state },params) {
    //   return new Promise((resolve, reject) => {
    //     wechatBind(params).then(response => {
    //       const data = response.data
    //       commit('SET_CODEKEY', data.data.code_key)
    //       resolve(response)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    // 微信二维码登录接口
    getQrcodeLogin({ commit, state },params) {
      return new Promise((resolve, reject) => {
        qrcodeLogin(params).then(response => {
          const data = response.data
          commit('SET_CODEKEY', data.data.code_key)
          if(data.token){
            const tokenStr = data.token
            // console.log('tokenStr',tokenStr)
            setToken(tokenStr)
            commit('SET_TOKEN', tokenStr)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },


  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js